import { useSelector, useDispatch } from "react-redux"
import { Button, Col, Form, FormInstance, Row, Select, message, Spin, Typography, Descriptions, Tag, Input } from "antd"
import React, { useEffect, useState } from "react"
import { stepperMoving } from "../../stores/actions";
import { request } from '../../../../shared/src/apis';
import { deployedCompanies } from "../../utils/apisConsts"
import { OutPutResult } from '@operations/shared';
import helper from "../../utils/helper";
import { errorMessage } from "../../utils/commonStringsConsts";
import moment from 'moment';
import { assignUnidentifiedCollectionToCompany, assignUnidentifiedCollectionToUser } from '../../utils/apisConsts';
import { IUnidentifiedCollection } from "../../utils/commonInterfaces";
const { Option } = Select;
const { Text } = Typography
const AssignUnidentifiedCollection = () => {
  const unidentifiedCollectionInfo = useSelector((state: any) => state.actionsReducer.unidentifiedCollectionID);
  const [companies, setCompanies] = useState<any[]>([])
  const [loadingData, setLoadingData] = useState(false)
  const [errorMode, setErrorMode] = useState(false)
  const [loader, setLoader] = useState(false);
  const [isCompany, setIsCompany] = useState<boolean>(true);
  const formRef = React.createRef<FormInstance>();
  const dispatch = useDispatch()
  useEffect(() => {
    getCompanies()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const dropDownSearch = (input: string, option: { children: string; }) => {
    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }
  const getCompanies = async () => {
    try {
      setLoadingData(true)
      const companiesRes: { [key: string]: any } = await dispatch(request({ url: deployedCompanies, method: "GET" }))
      if (companiesRes?.data?.status === 200) {
        setCompanies(companiesRes?.data?.data)
      } else {
        message.error(companiesRes?.data?.message)
        setErrorMode(true)
      }
      setLoadingData(false)
    }
    catch (error: any) {
      setLoadingData(false)
      setErrorMode(true)
    }
  }

  const assignUnidentifiedCollection = async (values: IUnidentifiedCollection) => {
    setLoader(true);
    try {
      const payloadData = {
        unidentifiedDepositID: unidentifiedCollectionInfo?.id,
        ...(isCompany
          ? { companyID: values?.companyID }
          : { phone: values?.phone }),
      };
  
      const url = isCompany
        ? assignUnidentifiedCollectionToCompany
        : assignUnidentifiedCollectionToUser;
  
      const apiData: any = await dispatch(request({ method: 'POST', url, data: payloadData }));
      const res = await apiData?.data;
  
      if (res?.status === 201 || res?.status === 200) {
        message.success(res?.message, 5);
        dispatch(stepperMoving(0));
      } else {
        message.error(res?.message, 5);
      }
    } catch (error) {
      message.error(errorMessage, 5);
    } finally {
      setLoader(false);
    }
  };
  
  const changeInputs = async (value: boolean) => {
    value && await getCompanies()
    setIsCompany(value)
  }
  return (
    errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage ? errorMessage : 'Something went wrong, please refresh the page and try again'}
      btnTitle={'Refresh the page'} btnClick={helper.refreshPage} /> :
      <div className="createEarlyPayment">
        <Spin size="large" spinning={loadingData}>
          <Form name="nest-messages" onFinish={assignUnidentifiedCollection} ref={formRef} style={{ marginTop: '1rem' }}>
            <Row className="inputsRow">
              <Col span='12'>
                <label>Who Paid <span>*</span></label>
                <Form.Item
                  name="isCompany"
                  rules={[{ required: true, message: 'Required' }]}
                  initialValue={isCompany}
                >
                  <Select placeholder="Select a month" onChange={changeInputs}>
                    <Option value={true}>Company</Option>
                    <Option value={false}>User</Option>
                  </Select>
                </Form.Item>
              </Col>
              {isCompany === true ? (<Col span='12'>
                <label>Company {<span>*</span>}</label>
                <Form.Item
                  name="companyID"
                  rules={[{ required: true, message: 'Required' }]}
                >
                  <Select placeholder="Select a company" showSearch allowClear
                    filterOption={((input, option: any) => dropDownSearch(input, option))}
                  >
                    {Array.isArray(companies) &&
                      companies?.map((company: { id: number, name: string }) => <Option key={company?.id} value={company?.id} company={company}>{company?.name}</Option>)}
                  </Select>
                </Form.Item>
              </Col>
              ) : (
                <Col span='12'>
                  <label>User Phone</label>
                  <Form.Item
                    name="phone"
                    rules={[{ required: true, message: 'Required' },
                    { pattern: helper.regexValidation.egyptPhoneNum, message: 'Please enter Egyptian number' }]}
                  >
                    <Input placeholder="Enter a phone number" />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Row style={{ justifyContent: 'end' }}>
              <Col span='' className="btnCol">
                <Form.Item>
                  <Button shape="round" type="primary" block htmlType="submit" style={{ marginTop: '0.5rem', paddingInline: '1.5rem' }} loading={loader}>
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
        <Descriptions
          title="Collection Details"
          bordered
          column={1}
          size="small"
          labelStyle={{
            fontWeight: 600,
            backgroundColor: "#fafafa",
            width: "40%",
          }}
          contentStyle={{
            backgroundColor: "#fff",
            fontWeight: 500,
          }}
        >
          <Descriptions.Item label="Collection ID">
            <Tag color="blue">{unidentifiedCollectionInfo?.id}</Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Collection Amount">
            <Tag color="green">{unidentifiedCollectionInfo?.amount} </Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Collection Date">
            <Text strong>{moment(unidentifiedCollectionInfo?.collectionDate).format('LL')}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="reference Number">
            <Text code>{unidentifiedCollectionInfo?.referenceNumber}</Text>
          </Descriptions.Item>
        </Descriptions>
      </div>
  )
}

export default AssignUnidentifiedCollection